<template>
  <el-container
    direction="vertical"
    class="preview-ctr preview-ctr-welness"
    v-bind:style="{ background: layoutBackgroundColor }"
  >
    <header-comp :headerConfig="headerConfig" />
    <div class="fl-content-ctr">
      <div class="fl-content-ctr">
        <div class="comp-ctr">
          <ul
            role="menubar"
            class="el-menu-preview el-menu-preview-hor h_main-menu el-menu--horizontal el-menu"
            v-bind:style="{background: mainMenuBackgroundColor}"
          >
            <li
              role="menuitem"
              tabindex="0"
              class="el-menu-item is-active"
              v-bind:style="{ 
              color: mainMenuActiveTextColor,
              borderBottomColor: mainMenuActiveTextColor
               }"
            >Dashboard</li>
            <li
              role="menuitem"
              tabindex="0"
              class="el-menu-item"
              v-bind:style="{ 
              color: mainMenuTextColor
               }"
            >Accounts</li>
            <li
              role="menuitem"
              tabindex="0"
              class="el-menu-item"
              v-bind:style="{ 
              color: mainMenuTextColor
               }"
            >Transactions</li>
            <li
              role="menuitem"
              tabindex="0"
              class="el-menu-item"
              v-bind:style="{ 
              color: mainMenuTextColor
               }"
            >Fincheck</li>
            <li
              role="menuitem"
              aria-haspopup="true"
              class="el-submenu"
              tabindex="0"
              style="position:relative"
              v-bind:style="{ 
              color: mainMenuTextColor
               }"
            >
              <div
                class="el-submenu__title"
                v-bind:style="{ 
              color: mainMenuTextColor
               }"
              >
                Spending
                <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
              </div>
              <div
                class="el-menu--horizontal el-menu-preview-hor-sub"
                style="position: absolute; top: 60px; left: 20px; z-index: 2006;"
              >
                <ul
                  role="menu"
                  class="el-menu el-menu--popup el-menu--popup-bottom-start h_sub-menu"
                  style="padding-left:0"
                >
                  <li
                    role="menuitem"
                    tabindex="-1"
                    class="el-menu-item sub-menu-active"
                    v-bind:style="{ 
              color: subMenuActiveTextColor
               }"
                  >Expense/Income Analysis</li>
                  <li
                    role="menuitem"
                    tabindex="-1"
                    class="el-menu-item"
                    v-bind:style="{ 
              color: subMenuTextColor
               }"
                  >Cash Flow</li>
                  <li
                    role="menuitem"
                    tabindex="-1"
                    class="el-menu-item"
                    v-bind:style="{ 
              color: subMenuTextColor
               }"
                  >Budget</li>
                  <li
                    role="menuitem"
                    tabindex="-1"
                    class="el-menu-item"
                    v-bind:style="{ 
              color: subMenuTextColor
               }"
                  >Financial Forecast</li>
                </ul>
              </div>
            </li>
            <li
              role="menuitem"
              tabindex="0"
              class="el-menu-item"
              v-bind:style="{ 
              color: mainMenuTextColor
               }"
            >Investment</li>
          </ul>
        </div>
        <div>&nbsp;</div>
        <div class="sidebar-menu-ctr h_side-bar-menu">
          <ul
            role="menubar"
            class="el-menu-preview el-menu-preview-ver el-menu"
            v-bind:style="{ 
              background: sidebarBackgroundColor
               }"
          >
            <li
              role="menuitem"
              tabindex="-1"
              class="el-menu-item is-active"
              v-bind:style="{ 
              color: sidebarActiveTextColor,
              borderLeftColor: sidebarActiveTextColor
               }"
            >
              <span>Institution</span>
            </li>
            <li
              role="menuitem"
              tabindex="-1"
              class="el-menu-item"
              v-bind:style="{ 
              color: sidebarTextColor
               }"
            >
              <span>Account Type</span>
            </li>
            <li
              role="menuitem"
              tabindex="-1"
              class="el-menu-item"
              v-bind:style="{ 
              color: sidebarTextColor
               }"
            >
              <span>Account Groups</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import _ from 'underscore'
import Header from './../fastlink/flHeader.vue'
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  data() {
    return {
      activeIndex: '1'
    }
  },
  components: {
    'header-comp': Header
  },
  created() {},
  mixins: [custToolHelper],
  computed: {
    headerConfig() {
      let config = {
        headerText: 'Menus'
      }
      return config
    },
    layoutBackgroundColor() {
      return this.getItemDefaultValue('fl-finapp', 'layout_background_color')
    },
    mainMenuBackgroundColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'main-menu-bg',
        'main-menus'
      )
    },
    mainMenuTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'main-menu-default-text-color',
        'main-menus'
      )
    },
    mainMenuActiveTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'main-menu-default-text-color-active',
        'main-menus'
      )
    },
    subMenuTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'main-menu-dropdown-text-default',
        'sub-menus'
      )
    },
    subMenuActiveTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'main-menu-dropdown-text-active',
        'sub-menus'
      )
    },
    sidebarBackgroundColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'vertical-tab-background',
        'sidebar-menus'
      )
    },
    sidebarTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'vertical-tab-text-color',
        'sidebar-menus'
      )
    },
    sidebarActiveTextColor() {
      return this.getItemDefaultValue(
        'wellness-finapp',
        'vertical-tab-text-color-active',
        'sidebar-menus'
      )
    }
  },
  methods: {}
}
</script>

<style>
.preview-ctr-welness {
  width: 900px;
}
.comp-title {
  color: #747474;
  font-size: 16px;
  padding-bottom: 20px;
}
.sidebar-menu-ctr {
  width: 280px;
}
.el-menu-preview {
  padding-left: 0px !important;
}
.el-menu-preview .el-menu-item,
.el-menu-preview > .el-submenu .el-submenu__title {
  text-transform: uppercase;
  font-weight: bold;
  cursor: default;
}

.el-menu-preview-hor-sub.el-menu--horizontal .el-menu .el-menu-item {
  border-bottom: 1px solid #eeefee;
  font-size: 16px;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  font-weight: 600;
  cursor: default;
}

.el-menu-preview-hor-sub.el-menu--horizontal .el-menu .el-menu-item:last-child {
  border-bottom: 0px solid #eeefee;
}
.el-menu-preview-hor-sub.el-menu--horizontal .el-menu .el-menu-item {
  background: transparent;
  text-transform: capitalize;
  font-size: 15px;
}
.el-menu-preview-hor-sub.el-menu--horizontal {
}
.el-menu-preview-hor-sub.el-menu--horizontal ul::before {
  /* content: '';
  display: block;
  width: 0;
  height: 0;
  border: inset 8px;
  border-color: transparent transparent #fff transparent;
  border-bottom-style: solid;
  position: absolute;
  top: -16px;
  left: 12px; */
}
.el-menu-preview-hor-sub.el-menu--horizontal .el-menu .el-menu-item:hover {
  background-color: #eeefee;
}
.el-menu-preview-hor {
  font-size: 16px;
}
.el-menu-preview-hor .el-menu-item.is-active {
  border-bottom-width: 4px !important;
}
.el-menu-preview-hor .el-menu-item:hover,
.el-menu-preview-hor .el-submenu__title:hover,
.el-menu-preview-hor > .el-menu-item:not(.is-disabled):focus {
  background: transparent !important;
}

.el-menu-preview-ver .el-menu-item:first-child {
  border-top: 1px solid #eeefee;
}
.el-menu-preview-ver .el-menu-item {
  border-bottom: 1px solid #eeefee;
  border-left: 1px solid #eeefee;
}
.el-menu-preview-ver .el-menu-item.is-active {
  border-left: 4px solid #0c76be;
}
.el-menu-preview-ver .el-menu-item:hover,
.el-menu-preview-ver .el-menu-item:focus {
  background-color: transparent !important;
}
</style>
